import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=2170fe12"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2170fe12')) {
      api.createRecord('2170fe12', component.options)
    } else {
      api.reload('2170fe12', component.options)
    }
    module.hot.accept("./UserList.vue?vue&type=template&id=2170fe12", function () {
      api.rerender('2170fe12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/UserList.vue"
export default component.exports